import api from '@/api'

const state = {
  certSkuData: {}, // 资质信息包含资质+sku
  qualifications: {} // 修改，创建需要提交的资质信息
}

const mutations = {
  modifyQualification (state, data) {
    state.qualifications = data
  },
  modifyCertSkuData (state, data) {
    state.certSkuData = data
  }
}
const getters = {
  loginSupplier: state => {
    return state.loginSupplier
  }
}
const actions = {
  // 查询合同分类
  getSupplierContract ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getSupplierContract(data).then(res => {
        const resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          reject({from: '/api/srm/com.sprucetec.pms.srm.service.SupplierContractService/listNoDupliacateByFSupplierBasic', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/api/srm/com.sprucetec.pms.srm.service.SupplierContractService/listNoDupliacateByFSupplierBasic', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getGoodsCertList ({commit, dispath}, data) { // 获取资质页面数据
    return new Promise((resolve, reject) => {
      api.getCertList(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/queryList', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/queryList', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  editCert ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.modifyCert(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/add', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/add', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  createCert ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.createCert(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/add', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/add', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  modifyCert ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.modifyCert(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/modify', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/modify', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  delCert ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.delCert(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/delete', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/delete', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getCertAuditLogList ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getCertAuditLogList(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/getLogList', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/getLogList', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getSupplierDocumentChangePageList ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getSupplierDocumentChangePageList(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/getSupplierDocumentChangePageList', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/getSupplierDocumentChangePageList', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getCertDetail ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getCertDetail(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          commit('modifyCertSkuData', data)
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/getDetail', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/getDetail', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getNewCertDetail ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getNewCertDetail(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          commit('modifyCertSkuData', data)
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/getNewDetail', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/getNewDetail', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  validateCertClass ({commit, dispath}, data) { // 校验资质分类
    return new Promise((resolve, reject) => {
      api.validateCertClass(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/getDetail', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/getDetail', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  queryBindSkuList ({commit, dispath}, data) { // 资质绑定sku列表查询
    return new Promise((resolve, reject) => {
      api.queryBindSkuList(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({from: '/sweb/qualification/queryBindSkuList', error: resData.error})
        }
      }).catch(() => {
        reject({from: '/sweb/qualification/queryBindSkuList', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/goodsCert.js